const PROMPT_ID_PARAM = "promptId";
const PROJECT_IQ_HOSTNAME_MARKER = "projectiq";
const WORKSPACE_PATH_PATTERN = /^\/workspace\/[^/]+/;

export const resolveWorkspaceLinkUrl = (
  url: string,
  workspaceId: string | undefined,
): string => {
  if (!workspaceId) return url;

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(url);
  } catch {
    return url;
  }

  const isProjectIqUrl =
    parsedUrl.hostname.toLowerCase().includes(PROJECT_IQ_HOSTNAME_MARKER) ||
    parsedUrl.origin === window.location.origin;
  const hasPromptId = parsedUrl.searchParams.has(PROMPT_ID_PARAM);
  const hasWorkspacePath = WORKSPACE_PATH_PATTERN.test(parsedUrl.pathname);
  if (!isProjectIqUrl || !hasPromptId || hasWorkspacePath) return url;

  parsedUrl.pathname = `/workspace/${encodeURIComponent(workspaceId)}/chat`;
  return parsedUrl.toString();
};
